// SPDX-License-Identifier: LicenseRef-Proprietary

/**
 * Words that should remain lowercase (unless first word)
 * Articles, conjunctions, and common prepositions
 */
const LOWERCASE_WORDS = new Set([
  // Articles
  'a', 'an', 'the',
  // Coordinating conjunctions
  'and', 'but', 'or', 'nor', 'for', 'so', 'yet',
  // Prepositions
  'of', 'in', 'on', 'at', 'to', 'for', 'with', 'by', 'from', 'up', 'about', 'into', 'through', 'during', 'including', 'against', 'among', 'throughout', 'despite', 'towards', 'toward', 'upon', 'concerning', 'via', 'across', 'behind', 'beyond', 'near', 'plus', 'except', 'like', 'minus', 'round', 'off', 'over', 'under', 'above', 'below', 'out', 'down', 'around', 'between', 'within', 'without', 'along', 'amid', 'beside', 'besides', 'beneath', 'inside', 'outside', 'underneath', 'unlike', 'until', 'versus'
]);

/**
 * Apply APA capitalization rules to journal names
 * Capitalizes major words (nouns, verbs, adjectives, adverbs, pronouns)
 * Keeps articles, prepositions, and conjunctions lowercase unless first word
 * 
 * @param journal - Journal name to format
 * @returns Formatted journal name following APA style
 */
export function formatJournalNameAPA(journal: string): string {
  if (!journal) return journal;
  
  const words = journal.split(/\s+/);
  return words.map((word, index) => {
    // Remove leading/trailing punctuation for checking
    const wordMatch = word.match(/^([^\w]*)(\w+)([^\w]*)$/);
    if (!wordMatch) return word;
    
    const [, leadingPunct, coreWord, trailingPunct] = wordMatch;
    const lowerWord = coreWord.toLowerCase();
    
    // Always capitalize first word
    if (index === 0) {
      return leadingPunct + coreWord.charAt(0).toUpperCase() + coreWord.slice(1).toLowerCase() + trailingPunct;
    }
    
    // Check if word should be lowercase
    if (LOWERCASE_WORDS.has(lowerWord)) {
      return leadingPunct + lowerWord + trailingPunct;
    }
    
    // Capitalize major words
    return leadingPunct + coreWord.charAt(0).toUpperCase() + coreWord.slice(1).toLowerCase() + trailingPunct;
  }).join(' ');
}

